function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.033.746c.14-.534.688-.853 1.222-.713s.853.688.712 1.222C5.243 4.008 3.704 5.91 1.382 6.869.872 7.08.287 6.837.076 6.327c-.21-.51.032-1.096.543-1.306C2.334 4.313 3.46 2.919 4.033.746z",
  opacity: 0.5,
  transform: "translate(-33 -963) translate(16 939) translate(17 24) translate(11 12)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.19 1.36c.453-.204.978-.227 1.447-.068l.173.068 7 3.11c.672.299 1.126.946 1.184 1.673L21 6.3V11c0 5.55-3.84 10.74-9 12-5.066-1.237-8.86-6.263-8.996-11.698L3 11V6.3c0-.737.41-1.414 1.05-1.76l.14-.07 7-3.11zm.809 1.828l-6.997 3.11L5 11c0 4.386 2.866 8.492 6.71 9.831l.29.094.038-.01c3.885-1.218 6.834-5.257 6.958-9.63L19 11V6.3l-7.001-3.112z",
  transform: "translate(-33 -963) translate(16 939) translate(17 24)"
})))));

function SvgIconShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.2c6346d2.svg";
export { ForwardRef as ReactComponent };